import { Component, OnDestroy, OnInit } from '@angular/core';
import { DoggyhubService } from '../doggyhub.service';
import { Subscription } from 'rxjs';
import { GetDailyFactResponseDTO } from '../doggyhub.dto';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-dailyfact',
  templateUrl: './dailyfact.page.html',
  styleUrls: ['./dailyfact.page.scss'],
})
export class DailyfactPage implements OnInit, OnDestroy {
  isLoading = true;
  factSub: Subscription;
  fact: GetDailyFactResponseDTO;
  factDate: string;
  constructor(private doggyhubService: DoggyhubService) {}

  ngOnInit() {
    this.factSub = this.doggyhubService.getLatestFact().subscribe((res) => {
      this.fact = res;
      this.factDate = this.formatDateTime(this.fact.date);
      this.isLoading = false;
    });
  }
  ngOnDestroy() {
    if (this.factSub) this.factSub.unsubscribe();
  }

  formatDateTime(myDate: Date) {
    const format = 'dd-MMM-yyyy';
    const locale = 'en-US';
    const formattedDate = formatDate(myDate, format, locale).split(' ');
    return formattedDate[0];
  }

  getFact(isNext: boolean) {
    this.isLoading = true;
    this.factSub = this.doggyhubService
      .getFact(this.fact.id, isNext)
      .subscribe((res) => {
        this.fact = res;
        this.factDate = this.formatDateTime(this.fact.date);
        this.isLoading = false;
      });
  }
}
